import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

const initialState: { data: number[] } = {
  data: [],
};

export const multiSelectSubtitution = createSlice({
  name: 'multiSelectSubtitution',
  initialState,
  reducers: {
    setVacations: (state, { payload }: PayloadAction<number[]>) => {
      state.data = payload;
    },
  },
});

const multiSelectedSubtitutionVacations = (state: RootState) => state.entities.vacationsSchedule.multiSelectSubtitution;
export const getMultiSelectedSubtitutionVacations = createSelector(multiSelectedSubtitutionVacations, state => state);

export const { setVacations } = multiSelectSubtitution.actions;
export const reducer = multiSelectSubtitution.reducer;
